import React, { useState } from "react";
import classNames from "classnames"
import * as styles from "./Accordion.module.scss"
import AccordionIcon from "../Icons/AccordionIcon";

export interface AccordionItem {
	id?: string | number;
	title: React.ReactNode;
	content: React.ReactNode;
}

interface AccordionProps {
	items: AccordionItem[];
	defaultOpenIndexes?: number[];
	allowMultipleOpen?: boolean;
}

const Accordion: React.FC<AccordionProps> = ({
	items,
	defaultOpenIndexes = [],
	allowMultipleOpen = false,
}) => {
	const [openIndexes, setOpenIndexes] = useState<number[]>(defaultOpenIndexes);

	const toggle = (index: number) => {
		if (openIndexes.includes(index)) {
			setOpenIndexes(openIndexes.filter((i) => i !== index));
		} else {
			setOpenIndexes(
				allowMultipleOpen ? [...openIndexes, index] : [index]
			);
		}
	};



	return (
		<div className={styles.accordion}>
			{items.map((item, index) => {
				const isOpen = openIndexes.includes(index);

				const accordionPanelClasses = classNames(styles.accordionPanel, {
					[styles.accordionPanelOpen]: isOpen
				})
				const accordionIconClasses = classNames(styles.accordionIcon, {
					[styles.accordionIconOpen]: isOpen
				})
				return (
					<div key={item.id ?? index} className={styles.accordionItem}>
						<button
							type="button"
							className={styles.accordionHeader}
							onClick={() => toggle(index)}
						>
							<span>{item.title}</span>
							<span className={accordionIconClasses}><div className={styles.accordionIconContainer}><AccordionIcon className={styles.accordionIconImage} /></div></span>
						</button>
						<div className={accordionPanelClasses}>
							<div className={styles.accordionContent}>{item.content}</div>
						</div>
					</div>
				);
			})}
		</div>
	);
};

export default Accordion;
